const f = (e, r) => {
  let t = r.indexOf(e);
  for (; t !== -1; ) {
    const s = t === 0 ? "" : r[t - 1], o = t + e.length >= r.length ? "" : r[t + e.length];
    if (t === 0 && o === "-") return !0;
    const n = s === "" || !/\d/.test(s) && s !== "-", a = o === "" || !/\d/.test(o) && o !== "-";
    if (n && a) return !0;
    t = r.indexOf(e, t + 1);
  }
  return !1;
}, p = (e, r) => {
  if (r.includes(e)) return !0;
  const t = e.replace(/[^\w]+$/, "");
  return !!t && r.startsWith(t);
}, g = (e, r = "") => {
  const s = r.replace(/'/g, " ").replace(/[|<>&@!()*:]/g, "").trim().split(",").map((n) => n.trim()).filter(Boolean), o = [e.name, e.code, e.city, e.zipcode, e.address_full].map((n) => (n ?? "").toLowerCase());
  return s.length === 0 || s.some((n) => n.split(/\s+/).filter(Boolean).every((l) => {
    const c = l.toLowerCase(), u = /[^\w]/.test(c), m = /^\d+$/.test(c);
    if (u)
      return o.some((i) => p(c, i));
    if (m)
      return o.some((i) => f(c, i));
    const d = new RegExp(`\\b${c}`);
    return o.some((i) => d.test(i));
  }));
};
export {
  g as isBusinessInQuery
};
